import { BusyIndicator } from "./BusyIndicator";
import type { BusyIndicatorProps } from "./BusyIndicator";
import "./BusyIndicatorCss.css";

export default function BusyIndicatorHTML(props: BusyIndicatorProps) {
  const { children, isOpen, message, mode } = BusyIndicator(props);

  if (mode === "section") {
    return (
      <div className="busy-indicator-wrapper">
        {children}
        {isOpen && (
          <div
            className="busy-indicator-section"
            role="status"
            aria-live="polite"
            aria-busy="true"
          >
            <BusyIndicatorContent message={message} />
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {children}
      {isOpen && (
        <div
          className="busy-indicator-overlay"
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <BusyIndicatorContent message={message} />
        </div>
      )}
    </>
  );
}

interface BusyIndicatorContentProps {
  message: string;
}

function BusyIndicatorContent({ message }: BusyIndicatorContentProps) {
  return (
    <div className="busy-indicator-content">
      <div className="busy-indicator-spinner" aria-hidden="true" />
      <p className="busy-indicator-message">{message}</p>
    </div>
  );
}
